export const USER_NAME_MAP = 'user-name-map';
export const USER_SIGNED_JWT_MAP = 'user-signed-jwt-map';
export const MUTED = 'muted';
export const INNERHEIGHT = 'innerHeight';
